import { render, staticRenderFns } from "./chat-reply-preview.vue?vue&type=template&id=26f212f6&scoped=true&"
import script from "./chat-reply-preview.vue?vue&type=script&lang=js&"
export * from "./chat-reply-preview.vue?vue&type=script&lang=js&"
import style0 from "./chat-reply-preview.vue?vue&type=style&index=0&id=26f212f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f212f6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f212f6')) {
      api.createRecord('26f212f6', component.options)
    } else {
      api.reload('26f212f6', component.options)
    }
    module.hot.accept("./chat-reply-preview.vue?vue&type=template&id=26f212f6&scoped=true&", function () {
      api.rerender('26f212f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-reply-preview/chat-reply-preview.vue"
export default component.exports